import React, { createContext, useContext } from 'react';
import { createPersistedState } from '@edreamsodigeo/frontend-core';

export const SessionContext = createContext(null);

const usePersistedPfSession = createPersistedState({
  key: 'pf:session',
  type: 'sessionStorage',
  isGlobal: true,
});

function _PFSessionProvider({ children }) {
  return (
    <SessionContext.Provider value={usePersistedPfSession}>
      {children}
    </SessionContext.Provider>
  );
}

export const PFSessionProvider = React.memo(_PFSessionProvider);

export function usePFSessionContext() {
  return useContext(SessionContext);
}
